import React, { useContext ,useEffect, useState,useRef} from 'react'
import { Context } from "../context/Context"
import {quranDetails} from "../Database/Database";
import { useLocation, useParams } from 'react-router-dom'
import axios from 'axios';
import { getHeaders,base } from '../Config';
import queryString from "query-string";


function Alfatiha() {
    const { lang,theme } = useContext(Context);
    const location = useLocation();
    const { heading } = location.state;
    const {id} = useParams();
    const [surahAudio , setsurahAudio] = useState();
    console.log("this is id from prams ---->",id)
    console.log(typeof id)
    console.log("heading ------>",heading)


    const playIcon = require("../assets/red/play_button_audio.png");
    const pauseIcon = require("../assets/red/pause_button_audio.png");

    let songs = [
        {fileSource : surahAudio ,name : "audio_track_1", id : "id_1" }
     //    {fileSource : audio2 ,name : "audio_track_2", id : "id_2" }
     ];

     const audioRef = useRef(null);
     const [isPlaying,setIsPlaying] = useState(false);
    const [currentSong,setCurrentSong] = useState(songs[0]);
     const {handleShowLoader} = useContext(Context)
     const [quranDetailsData , setquranDetailsData] = useState();
    //  console.log("current Song", currentSong);

     let params = queryString.parse(location.hash)
     const uid = Object.values(params)
    //  console.log("params -------> ", uid)


    const fetchQuranDetails = () => {
        console.log("id while running the api funciton ---> ",id)
        handleShowLoader(true)
        axios({
            method: 'post',
            url: base + "quranData",
            data: JSON.stringify({'surah': 1}),
            headers: {...getHeaders() , Language: `${lang}`}
            }
        ).then((resp) => {
                console.log("test response ----> ", resp.data.quranData)
                setquranDetailsData(resp.data.quranData)
                setsurahAudio(resp.data.audio)
                songs[0].fileSource = resp.data.audio;
                handleShowLoader(false)
        }).then((error) => {
            console.log("error -----> ", error)
        })
    }


    useEffect(fetchQuranDetails,[])

    const endSongHandle = () => {
        // console.log("inside next auto play")
        // let currentIndex = songs.findIndex((song) => song.name === currentSong.name);
        // setCurrentSong(songs[currentIndex + 1]);

        // if (isPlaying) {
        //   setTimeout(()=>audioRef.current.play(),100);
        // }
    };

    // useEffect(() => {
    //     if(isPlaying){
    //         audioRef.current.play()
    //     } else if (audioRef.current){
    //         audioRef.current.pause()
    //     }
    //     console.log("is playing :",isPlaying)
    // },[isPlaying])

    const handlePlayPause = () => {
        if (isPlaying) {
            audioRef.current.pause();
            setIsPlaying(false);
          } else {
            audioRef.current.play();
            setIsPlaying(true);
          }
    }

  return (
    <div className='min-h-screen h-full pt-20 max-width'>
        <div className='w-full flex'>
            <div className='ml-4 w-10 h-10' onClick={handlePlayPause} > <img src= {isPlaying ? pauseIcon : playIcon} /> </div>
            <div className='w-3/4 mx-auto left-0 right-0  pl-3'>
                <div className={`${theme === "red" ? "bg-red_surah_name_board py-2 " :"bg-surah_name_board py-2" } text-white bg-contain  bg-no-repeat w-3/4 h-20`}>{heading ? heading : ""}</div>
            </div>
        </div>
        <div className='bg-slate-100 border h-75v overflow-y-auto w-11/12 mx-auto -my-4'>
            {
             quranDetailsData && quranDetailsData.map((element, index) =>  {
                return (
                    <div key={index} className='border-b py-4 px-1 wrap'>
                        <div className='mt-2'>
                            <div className={`py-2 ${theme === "red" ? "bg-red_surah_number bg-contain": "bg-surah_number" }  bg-no-repeat bg-center `}>{index+1}</div>
                            {/* <div className='my-2'>{element["ar"]}</div>
                            <div className='my-2'>{element[lang]}</div> */}

                            <div className='my-2'>{element.v_word}</div>
                            <div className='my-2'>{element.v_default_translation}</div>
                        </div>
                        <audio
                            ref={audioRef}
                            src={currentSong?.fileSource}
                            onEnded={endSongHandle}
                        ></audio>
                    </div>
                )
               })
            }
        </div>
    </div>
  )
}

export default Alfatiha